import React, { useState, useEffect, useRef } from 'react';
import { Box, InputBase } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { alpha } from '@mui/material/styles';

const SearchBar = ({ value = '', onChange, placeholder = 'Search...' }) => {
  const [localValue, setLocalValue] = useState(value);
  const debounceTimer = useRef(null);

  useEffect(() => { setLocalValue(value); }, [value]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setLocalValue(newValue);
    if (debounceTimer.current) clearTimeout(debounceTimer.current);
    debounceTimer.current = setTimeout(() => onChange(newValue), 400);
  };

  useEffect(() => {
    return () => { if (debounceTimer.current) clearTimeout(debounceTimer.current); };
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#F1F3F4',
        borderRadius: '8px',
        px: 1.5,
        py: 0.75,
        minWidth: 280,
        border: '1px solid transparent',
        transition: 'all 0.2s ease',
        '&:focus-within': {
          backgroundColor: '#fff',
          borderColor: '#1A73E8',
          boxShadow: '0 1px 2px 0 rgba(60,64,67,0.3), 0 2px 6px 2px rgba(60,64,67,0.15)',
        },
      }}
    >
      <SearchIcon sx={{ color: 'text.secondary', fontSize: 20, mr: 1 }} />
      <InputBase
        value={localValue}
        onChange={handleChange}
        placeholder={placeholder}
        sx={{
          flex: 1,
          fontSize: '0.875rem',
          '& input::placeholder': { color: 'text.secondary', opacity: 0.6 },
        }}
      />
    </Box>
  );
};

export default SearchBar;
